import { useMutation } from "@apollo/client";
import {
  Customer,
  CustomerInput,
} from "@towersystems/roam-common/lib/generated-types";
import { useCallback } from "react";
import {
  MUTATION_CREATE_CUSTOMER,
  MUTATION_UPDATE_CUSTOMER,
} from "./constants";

export const useMutationUpdateCustomer = () => {
  const [m] = useMutation<{
    updateCustomer: Customer;
  }>(MUTATION_UPDATE_CUSTOMER);
  const updateCustomer = useCallback(
    (input: CustomerInput) => {
      return m({ variables: { input } }).then((d) => {
        if (!d.data) {
          throw new Error();
        }
        return d.data?.updateCustomer;
      });
    },
    [m]
  );
  return {
    updateCustomer,
  };
};

export const useMutationCreateCustomer = () => {
  const [m] = useMutation<{
    createCustomer: Customer;
  }>(MUTATION_CREATE_CUSTOMER);
  const createCustomer = useCallback(
    (input: CustomerInput) => {
      return m({ variables: { input } }).then((d) => {
        if (!d.data) {
          throw new Error();
        }
        return d.data?.createCustomer;
      });
    },
    [m]
  );
  return {
    createCustomer,
  };
};
